module.exports = __webpack_public_path__ + "img/kubulus-logo-dunkel.69a9015d.svg";